export default __webpack_public_path__ + "static/media/lsd-bg-2.1a614829.webp";